import '@vaadin/notification';
import { componentName, NotificationCardClass } from './NotificationCardClass';

customElements.define(componentName, NotificationCardClass);

export { NotificationCardClass };
